<span class="date">
  <ng-container *ngFor="let sector of sectors; let first = first; let last = last">
    <ng-container *ngIf="isOneWay(first, last); else roundTrip">
      <app-ds-typography 
        [fontFamily]="fontFamily.SemiBold" 
        [size]="fontSize.XXS"
        [color]="fontColor.Primary"
        [text]="sector.Flights[0].DepartureDate | date: 'EE, d MMM' | dateFormat | titlecase">
      </app-ds-typography>
    </ng-container>
    <ng-template #roundTrip>
      <ng-container *ngIf="first">
        <app-ds-typography 
          [fontFamily]="fontFamily.SemiBold" 
          [size]="fontSize.XXS"
          [color]="fontColor.Primary"
          [text]="sector.Flights[0].DepartureDate | date: 'EE, d MMM' | dateFormat | titlecase">
        </app-ds-typography>
        <app-ds-typography 
          [fontFamily]="fontFamily.SemiBold" 
          [size]="fontSize.XXS"
          [color]="fontColor.Primary"
          [text]="' - '">
        </app-ds-typography> 
      </ng-container>
      <ng-container *ngIf="last">
        <app-ds-typography 
          [fontFamily]="fontFamily.SemiBold" 
          [size]="fontSize.XXS"
          [color]="fontColor.Primary"
          [text]="sector.Flights[0].DepartureDate | date: 'EE, d MMM' | dateFormat | titlecase">
        </app-ds-typography>
      </ng-container>
    </ng-template>
  </ng-container>
</span>